import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card rounded-0 border-0 shadow-sm mb-5" }
const _hoisted_2 = { class: "card-img-container position-relative photo-wrapper" }
const _hoisted_3 = { class: "card-img-overlay overlay-mask overlay-logo text-center p-0" }
const _hoisted_4 = { class: "overlay-mask-content text-center w-100 position-absolute" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Read more")
const _hoisted_6 = { class: "card-body pb-4" }
const _hoisted_7 = { class: "card-title text-truncate mb-2" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = { class: "meta list-inline mb-1" }
const _hoisted_10 = { class: "list-inline-item me-3" }
const _hoisted_11 = { class: "excerpt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        class: "card-img-top rounded-0 object-fit-cover",
        src: _ctx.blogPost.thumbnail,
        alt: ""
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: { name: `blog-${_ctx.blogPost.slug}` }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode(_component_router_link, {
          class: "overlay-mask-link position-absolute w-100 h-100",
          to: { name: `blog-${_ctx.blogPost.slug}` }
        }, null, 8, ["to"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("h4", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "text-link",
          to: { name: `blog-${_ctx.blogPost.slug}` }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.blogPost.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("ul", _hoisted_9, [
          _createVNode("li", _hoisted_10, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'clock'],
              class: "me-2"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.blogPost.publishedAt.toDateString()), 1)
          ])
        ]),
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.blogPost.intro), 1)
      ])
    ])
  ]))
}